import { getOnlyDigitalString } from 'legacy/lut/helpers/string/getOnlyDigitalString'

import {
  DEFAULT_PHONE_NUMBER_LENGTH,
  DEFAULT_PHONE_NUMBER_MASK,
  EXTENDED_PHONE_NUMBER_MASK,
} from '../../../configs'

export const getPhoneNumberWithMask = (phoneNumber: string = '') => {
  const onlyDigital = getOnlyDigitalString(phoneNumber)

  const mask =
    phoneNumber.length <= DEFAULT_PHONE_NUMBER_LENGTH
      ? DEFAULT_PHONE_NUMBER_MASK
      : EXTENDED_PHONE_NUMBER_MASK

  return mask.reduceRight((result, step) => {
    const onlyDigitalResult = getOnlyDigitalString(result)
    const onlyDigitalResultLength = onlyDigitalResult.length
    const onlyDigitalLength = onlyDigital.length
    const diff = onlyDigitalLength - onlyDigitalResultLength

    if (onlyDigitalResultLength >= onlyDigitalLength) {
      return result
    }

    const chunkOfNumber = onlyDigital.slice(0, diff).slice(-step)

    if (result) {
      return chunkOfNumber + '-' + result
    }

    return chunkOfNumber
  }, '')
}
